// Player injury validation -- iteration 146
import { z } from "zod";
import { INJURY_TYPES } from "../types/player-injury.js";

const dateString = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Date must be YYYY-MM-DD");

export const createPlayerInjurySchema = z.object({
  type: z.enum(INJURY_TYPES).default("general"),
  injury_type: z.string().max(255).nullable().optional(), // 156 -- specific label
  injured_on: dateString,
  return_to_train_on: dateString.nullable().optional(), // 156
  earliest_return_on: dateString.nullable().optional(), // 156 -- return-to-play estimate (general)
  event_id: z.string().nullable().optional(), // 156 -- where it occurred
  match_id: z.string().nullable().optional(),
  note: z.string().max(2000).nullable().optional(),
});

export const clearPlayerInjurySchema = z.object({
  cleared_on: dateString.optional(), // defaults to today server-side
  cleared_by: z.string().min(1, "Who cleared the player is required").max(255),
  clearance_note_url: z.string().max(2048).nullable().optional(), // 156 -- doctor's note
  return_to_train_on: dateString.nullable().optional(), // 156
});

export type CreatePlayerInjuryInput = z.infer<typeof createPlayerInjurySchema>;
export type ClearPlayerInjuryInput = z.infer<typeof clearPlayerInjurySchema>;
